import { Create } from "react-admin";
import { CardDesignForm } from "./Form";

export function CardDesignCreate() {
  return (
    <Create redirect="list">
      <CardDesignForm />
    </Create>
  );
}
